import { render, staticRenderFns } from "./BuildingList.vue?vue&type=template&id=7a21af17&"
import script from "./BuildingList.vue?vue&type=script&lang=js&"
export * from "./BuildingList.vue?vue&type=script&lang=js&"
import style0 from "./BuildingList.vue?vue&type=style&index=0&id=7a21af17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports